import Splide from '@splidejs/splide'
import '@splidejs/splide/css/core'
import { Controller } from 'stimulus'
import { haptics } from '~/common/helpers/haptics'

export default class extends Controller {
  static targets = [
    'splide',
    'scrollLeftButton',
    'scrollRightButton',
    'leftArrowContainer',
    'rightArrowContainer',
  ]

  static values = {
    arrowStyle: String,
  }

  connect() {
    this.splides = this.splideTargets.map((el, i) => this.#initSplide(el, i))
  }

  disconnect() {
    this.splides?.forEach((s) => s?.destroy())
    this.splides = []
  }

  scrollLeft(event) {
    this.splides[this.#indexForButton(event.currentTarget)]?.go('<')
  }

  scrollRight(event) {
    this.splides[this.#indexForButton(event.currentTarget)]?.go('>')
  }

  #indexForButton(buttonEl) {
    const idx = this.leftArrowContainerTargets.findIndex((c) => c.contains(buttonEl))
    if (idx >= 0) return idx
    const ridx = this.rightArrowContainerTargets.findIndex((c) => c.contains(buttonEl))
    return ridx >= 0 ? ridx : 0
  }

  #initSplide(el, domIndex) {
    const list = el.querySelector('.splide__list')
    if (!list) return null
    Array.from(list.children).forEach((child) =>
      child.classList.add('splide__slide')
    )

    const gapUnits = parseInt(el.dataset.gapClass?.match(/\d+/)?.[0] || '3', 10)
    const gap = `${gapUnits * 0.25}rem`

    const splide = new Splide(el, {
      type: 'slide',
      autoWidth: true,
      perMove: 1,
      arrows: false,
      pagination: false,
      drag: true,
      gap,
      trimSpace: true,
    })

    splide.on('mounted moved overflow', () => this.#updateArrows(splide, domIndex))
    // Detent tick each time the carousel lands on a new slide (swipe or arrow).
    splide.on('move', () => haptics.tick())
    splide.mount()
    return splide
  }

  #updateArrows(splide, domIndex) {
    const canScrollLeft = splide.index > 0
    const canScrollRight = splide.index < splide.Components.Controller.getEnd()
    const canScroll = canScrollLeft || canScrollRight

    if (this.arrowStyleValue === 'inline') {
      const left = this.leftArrowContainerTargets[domIndex]
      const right = this.rightArrowContainerTargets[domIndex]
      if (left) this.#toggleInactive([left], !canScrollLeft)
      if (right) this.#toggleInactive([right], !canScrollRight)
    } else {
      this.#toggleVisibility(this.leftArrowContainerTargets, canScroll)
      this.#toggleVisibility(this.rightArrowContainerTargets, canScroll)
      this.#toggleDisabled(this.scrollLeftButtonTargets, !canScrollLeft)
      this.#toggleDisabled(this.scrollRightButtonTargets, !canScrollRight)
    }
  }

  #toggleVisibility(elements, show) {
    elements.forEach((el) => el.classList.toggle('hidden', !show))
  }

  #toggleInactive(elements, inactive) {
    elements.forEach((el) => {
      el.classList.toggle('opacity-0', inactive)
      el.classList.toggle('pointer-events-none', inactive)
    })
  }

  #toggleDisabled(elements, disabled) {
    elements.forEach((el) => el.classList.toggle('t-btn-disabled', disabled))
  }
}
